import { jsx as _jsx } from "react/jsx-runtime";
import { AdSlotIds } from "@/shared/types";
import { AdContainer } from "../AdContainer";
import { useAdsContext } from "../../context";
import { RentalLinkCustomFallback } from "./RentalLinkCustomFallback";
export const RentalLink = () => {
    const { getAdSlot } = useAdsContext();
    if (!getAdSlot(AdSlotIds.RENTAL_LINK))
        return null;
    return (_jsx(AdContainer, { adSlotId: AdSlotIds.RENTAL_LINK, justifyContent: "flex-start", height: "sizing.24", maxHeight: "sizing.24", customFallback: _jsx(RentalLinkCustomFallback, {}) }));
};
